// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigatorСode-board-logo {
  display: grid;
  grid-template-rows: auto 3vw 3vw;
  gap: 1vw;
  width: inherit;
}

.navigatorСode-board-logo-image {
  margin-top: 1vw;
  place-self: end;
  position: relative;
  height: 24vw;
}

#navigatorСode-board-logo-button {
  position: relative;
  left: 1.5vw;
}

#navigatorСode-subtitle-board-logo {
  position: relative;
  left: 1.5vw;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/NavigatorСode/styles/NavigatorCodeBoardLogo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".navigatorСode-board-logo {\n  display: grid;\n  grid-template-rows: auto 3vw 3vw;\n  gap: 1vw;\n  width: inherit;\n}\n\n.navigatorСode-board-logo-image {\n  margin-top: 1vw;\n  place-self: end;\n  position: relative;\n  height: 24vw;\n}\n\n#navigatorСode-board-logo-button {\n  position: relative;\n  left: 1.5vw;\n}\n\n#navigatorСode-subtitle-board-logo {\n  position: relative;\n  left: 1.5vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
